import { Injectable, inject } from '@angular/core';
import { ASSETS_API } from '../ports';
import { ExplorerStore } from '../state/explorer.store';

@Injectable()
export class LoadAssetTypesUseCase {
  private readonly assetsApi = inject(ASSETS_API);
  private readonly store = inject(ExplorerStore);
  private _inFlight = false;

  async execute(): Promise<void> {
    if (this.store.isAssetTypesLoaded() || this._inFlight) return;

    this._inFlight = true;
    try {
      this.store.setAssetTypesLoading(true);
      this.store.setAssetTypesError(null);

      const { assetTypes } = await this.assetsApi.getAssetDefinitions();
      this.store.loadAssetTypes(assetTypes);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : 'Failed to load asset type definitions';
      this.store.setAssetTypesError(message);
    } finally {
      this._inFlight = false;
      this.store.setAssetTypesLoading(false);
    }
  }
}
